/* eslint-disable */
import { Reducer } from 'redux'

const customModule = '@LOADING'

const SET_LOADING = `${customModule}/SET_LOADING`

const initialState: boolean = false

export const loadingReducer: Reducer<boolean> = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_LOADING:
      return payload
    default:
      return state
  }
}


export const setLoading = (data: boolean) => ({ type: SET_LOADING, payload: data })
